import { Filters, PaginationProps, TableOptions } from '@/types';
import { BaseMutations } from '@/store/base-mutations';
import { default_subpartner } from '../services';
import { Subpartners } from '../types';
import SubpartnersState from './state';

export default class SubpartnersMutations extends BaseMutations<SubpartnersState> {
  SET_SUBPARTNERS(data: Subpartners.Subpartner[]) {
    this.state.subpartners = data;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof Filters, value: unknown }) {
    this.state.filters[key] = value;
  }

  SET_CURRENT_SUBPARTNER(data: Subpartners.Subpartner) {
    this.state.current_subpartner = data;
  }

  UPDATE_CURRENT_SUBPARTNER({ key, value } : { key: keyof Subpartners.Subpartner, value: unknown }) {
    this.state.current_subpartner[key] = value;
  }

  RESET_CURRENT_SUBPARTNER() {
    this.state.current_subpartner = default_subpartner();
  }

  SET_REGIONS(regions: string[]) {
    this.state.regions = regions;
  }

  SET_CITIES(cities: string[]) {
    this.state.cities = cities;
  }

  TOGGLE_SUBPARTNERS_LOADING(value: boolean) {
    this.state.subpartners_loading = value;
  }
}
